import type { FaireProductEntity } from "../../entity_types/product";

export const p_7t494ackhg: FaireProductEntity = {
  token: "p_7t494ackhg",
  type: "product",
  name: 'Crystal Confetti Lemon-Lime | Mahjong with a Sprinkle of Color and Joy | 1.25" x 0.9" x 0.7"',
  brandToken: "b_93g59u78gb",
  brandName: "My Fair Mahjong",
  imageUrl:
    "https://cdn.faire.com/fastly/fe75e62a50859ad8c593662636ee91c63e5bff101bf8fda4ace5a59853e9cd6b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5b70c76adfee251dcd1114ce53c9794e5f5d41250a1193b80d694dd0ac26aa31.png",
    "https://cdn.faire.com/fastly/382d16b70af038b16060ccac438fbd32cf13d2bd12d5bacab931d1e063bed88a.png",
    "https://cdn.faire.com/fastly/2d944cae2d6178d92561c5dba754b1f60db95235b653db6bfe3ff145f3d7a308.png",
    "https://cdn.faire.com/fastly/4685575fd72597905c4c339b273eb4641a04bb5dca9bf314fb890e9e0edf54ea.png",
    "https://cdn.faire.com/fastly/be6904a1d55406e58d568fc7dfd237a705db8b92333e544a77490ba325bc7b8d.png",
    "https://cdn.faire.com/fastly/6a954904358492c80b72054d2f9c65a7cafc765bb38533abd3666a03bb07245c.png",
    "https://cdn.faire.com/fastly/321c107f4837df33f97056266fea858a27ed6c85d813c5972cfb15ed12403017.png",
    "https://cdn.faire.com/fastly/e53f3f3cd3466f50031bb110d190ea50b0ecd6bbe6d5530058066eadd0846cfa.png",
    "https://cdn.faire.com/fastly/f3cd08d76a52c1e7d5465690c8796f90e3cf1a6429ab58f08a5bbb213ab22e69.png",
  ],
  priceDollars: 182.5,
  description:
    "Introducing the Confetti Series Tile Set in Lemon-Lime. Mahjong with a Sprinkle of Color and Joy. This set features labeled tiles for ease of play, making it an incredible set to teach with and excellent for players wanting a touch of whimsy, but who appreciate clear tile identification! This set is delightfully chunky and includes designs that are whimsical and confetti-inspired in nature, with little celebrations and nods throughout the set.\n\n𝐖𝐡𝐚𝐭'𝐬 𝐢𝐧 𝐭𝐡𝐞 𝐩𝐚𝐜𝐤𝐚𝐠𝐞?\nThe My Fair Mahjong Confetti Series includes:\n\n• 1 Yellow MFM Tile bag so that you can conveniently carry and store your tiles.\n• 1 Green & Yellow Zipper Tassel to add a little pizzaz.",
  tags: [],
  msrpDollars: 365,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:39.387Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
